/**
 * VRG-141 gap-0 — canonical `best_for_product_types` product-type master list.
 *
 * ⚠️ **The LIST now lives in `@repo/types`** (`packages/types/src/product/product-types.ts`),
 * moved there by VRG-573. This file re-exports it and keeps the platform-only helpers
 * below, so every existing import site here is untouched and there is still exactly one
 * definition.
 *
 * It moved because the API needs it too: `companies.categories` stores these exact
 * strings, market-data extraction must constrain an extracted claim's category to this
 * closed set, and outreach joins the two. A copy on each side would drift, and the drift
 * would be invisible — the join would simply return less (working-conventions §36, §47).
 *
 * Do NOT add a product type here. Add it to the `@repo/types` file.
 */

export type { ProductSector } from '@repo/types'
export { PRODUCT_SECTORS, ALL_PRODUCT_TYPES, REGULATED_PRODUCT_TYPES, canonicalProductType } from '@repo/types'

import { PRODUCT_SECTORS, REGULATED_PRODUCT_TYPES } from '@repo/types'

const TYPE_TO_SECTOR = new Map<string, string>(
  PRODUCT_SECTORS.flatMap(g => g.types.map(v => [v, g.sector] as const)),
)

/** The SECTOR a product type belongs to (null if unknown). */
export function sectorForProductType(type: string): string | null {
  return TYPE_TO_SECTOR.get(type) ?? null
}

export function isRegulatedProductType(type: string): boolean {
  return REGULATED_PRODUCT_TYPES.has(type)
}
